import { requireBetaFeatures } from '../../../../common/utils/requireBetaFeatures';

// @ngInject
const config = ($stateProvider) => {
  $stateProvider
    .state('variant.offers', {
      controller: 'OffersController as vm',
      resolve: { betaFeatures: requireBetaFeatures },
      parent: 'variant',
      url: '/offers',
      templateUrl: 'main/article/variant/offers/offers.tpl.html',
      data: { pageTitle: 'Offers' },
    })
    .state('variant.offers.group', {
      parent: 'variant',
      url: '/offers/group/{offerGroupId:[0-9]{1,11}}',
      templateUrl: 'main/article/variant/offers/offerGroup.tpl.html',
      resolve: {
        betaFeatures: requireBetaFeatures,
        offerGroupId: /* @ngInject */ ($stateParams) =>
          parseInt($stateParams.offerGroupId, 10),
        variantId: /* @ngInject */ ($stateParams) =>
          parseInt($stateParams.variantId, 10),
      },
      data: { pageTitle: 'Offer Group' },
    });
};

class OffersController {
  constructor($rootScope, variant) {
    'ngInject';

    this.variant = variant;
    this.article = variant.article;

    $rootScope.pageTitle = `${this.article.itemCode || ''} - Offers`;
    $rootScope.breadcrumbContext = {
      tabName: 'Offers',
      tabState: 'variant.offers',
      entityName: null,
    };
  }
}

angular
  .module('main.article.variant.offers', [])
  .config(config)
  .controller('OffersController', OffersController);
